import styles from "./App.module.css";

import logo from "./assets/logo.png";
import spotify from "./assets/spotify.png";
import soundcloud from "./assets/soundcloud.png";
import instagram from "./assets/instagram.png";
import band from "./assets/band.png";

const App = (props) => {
  return (
    <div className="d-flex flex-column">
      <h1 className={styles.text}>KRASSIC</h1>
      <div className={styles.container}>
        <video
          className={styles.bgVideo}
          src={`${process.env.PUBLIC_URL}/bg_video.mp4`}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className={styles.logoSection}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <div className="mt-5">
            <a href="https://open.spotify.com/intl-pt/artist/0L93bvVXkUB6vvaA6K2sdS?si=jDTh6pprTZuHrsseQs5xdQ">
              <img src={spotify} alt="Spotify" className={styles.link} />
            </a>
            <a href="https://soundcloud.com/krassic">
              <img src={soundcloud} alt="Soundcloud" className={styles.link} />
            </a>
            <a href="https://www.instagram.com/krass.ic/">
              <img src={instagram} alt="Instagram" className={styles.link} />
            </a>
          </div>
        </div>
        <div className={styles.textSection}>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
          <a href="#contact" className={styles.contactButton}>
            Contact Us
          </a>
        </div>
      </div>
      <section id="contact" className={styles.contactSection}>
        <div className={styles.contactRow}>
          <img src={band} alt="Krassic" className={styles.bandPhoto} />
          <form
            className={styles.contactForm}
            onSubmit={(e) => e.preventDefault()}
          >
            <h2 className={styles.contactHeading}>Get in Touch</h2>
            <p className={styles.contactSubtitle}>
              Whether it's a booking, a mentorship session, a mixing project,
              or a custom sound track — drop us a line and let's make it
              happen.
            </p>
          <div className={styles.formRow}>
            <input
              type="text"
              placeholder="Name"
              className={styles.input}
              required
            />
            <input
              type="email"
              placeholder="Email"
              className={styles.input}
              required
            />
          </div>
          <select className={styles.select} defaultValue="" required>
            <option value="" disabled hidden>
              Reason for contact
            </option>
            <option value="booking">Booking</option>
            <option value="mentorship">Mentorship</option>
            <option value="mixing">Mixing</option>
            <option value="sound-tracks">Sound Tracks</option>
            <option value="feedback">Feedback</option>
          </select>
          <textarea
            placeholder="Your message..."
            className={styles.textarea}
            rows="6"
            required
          />
            <button type="submit" className={styles.contactButton}>
              Send Message
            </button>
          </form>
        </div>
      </section>
      <footer className={styles.footer}>
        <span className={styles.footerBrand}>KRASSIC</span>
        <div className={styles.footerSocial}>
          <a href="https://open.spotify.com/intl-pt/artist/0L93bvVXkUB6vvaA6K2sdS?si=jDTh6pprTZuHrsseQs5xdQ">
            <img src={spotify} alt="Spotify" className={styles.footerIcon} />
          </a>
          <a href="https://soundcloud.com/krassic">
            <img
              src={soundcloud}
              alt="Soundcloud"
              className={styles.footerIcon}
            />
          </a>
          <a href="https://www.instagram.com/krass.ic/">
            <img
              src={instagram}
              alt="Instagram"
              className={styles.footerIcon}
            />
          </a>
        </div>
        <span className={styles.footerCopy}>
          © 2026 KRASSIC · All rights reserved
        </span>
      </footer>
    </div>
  );
};

export default App;
